import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ActiveSIP from "./ActiveSIP";
import CompletedSIP from "./CompletedSIP";
import "bootstrap/dist/css/bootstrap.min.css";
// import "./With.css";

const SIPControls = () => {
  const bonuses = [
    { title: "Active SIP", value: "active_sip" },
    { title: "Completed SIP", value: "completed_sip" },
  ];
  const [activeTab, setActiveTab] = useState(bonuses[0]);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");
    const activeTab =
      bonuses.find((bonus) => bonus.value === tab) || bonuses[0];
    setActiveTab(activeTab);
    // console.log("activeTab", activeTab)
  }, [location.search]);

  function handleTabClick(value) {
    setActiveTab(value);
    navigate(`?tab=${value.value}`);
  }
  return (
    <div className="container mt-4">
      <div className="tab-container">
        {bonuses.map((x, i) => (
          <div
            key={i}
            className={`tab ${x.value === activeTab.value ? "active" : ""}`}
            onClick={() => handleTabClick(x)}
          >
            {x.title}
          </div>
        ))}
      </div>
      <div className="tab-content">
        {activeTab.value === "active_sip" && <ActiveSIP />}
        {activeTab.value === "completed_sip" && <CompletedSIP />}
        {/*
    bonuses.map((x,i)=>{
        return <div style={{background: x?.value === activeTab.value ? "green" :"red" }} onClick={()=>handleTabClick(x)}>
        {x.title}
        </div>
        })
    */}
      </div>
    </div>
  );
};

export default SIPControls;
